function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 0a5 5 0 015 5v10a5 5 0 01-5 5H5a5 5 0 01-5-5V5a5 5 0 015-5h10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M15 2H5a3 3 0 00-2.995 2.824L2 5v10a3 3 0 002.824 2.995L5 18h10a3 3 0 002.995-2.824L18 15V5a3 3 0 00-2.824-2.995L15 2z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 13.5,
  r: 2.75
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 11h5v5H4zM10 9.75L13.5 4h-7z"
}));

function SvgQInteractiveTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref);
}

export default SvgQInteractiveTypeIcon;